import React from "react";


const draggingStyle = {
    opacity: 0.25,
};

const Drag = React.memo(
    (props: { dragImage: any; dataItem: any; type: any; dropEffect: any; children: React.ReactNode; }) => {
    const [isDragging, setIsDragging] = React.useState(false);
    const image = React.useRef(new Image());


    React.useEffect(() => {
        if (props.dragImage) {
            image.current = new Image();
            image.current.src = props.dragImage;
        }
    }, [props.dragImage]);


    const startDrag = (ev:any) => {
        setIsDragging(true);
        ev.dataTransfer.setData("drag-item", JSON.stringify(props.dataItem));
        ev.dataTransfer.setData("drag-type", props.type);
        ev.dataTransfer.effectAllowed = props.dropEffect;
        if (image.current) {
            ev.dataTransfer.setDragImage(image.current, 0, 0);
        }
    };

    const dragEnd = () => {
        setIsDragging(false);
    }

    return (
        <div style={isDragging ? draggingStyle : {}} draggable onDragStart={startDrag} onDragEnd={dragEnd}>
            {props.children}
        </div>
    );


});



export default Drag;
